import { AxiosRequestConfig } from "axios";

export const config: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_END_POINT,
  timeout: 40000,
  headers: {
    "content-type": "application/json"
  }
};
